(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lumerune-chain-picker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('lr-chain-picker')) {
    customElements.define('lr-chain-picker', class extends HTMLElement {
      connectedCallback() {
        this.prices = JSON.parse(this.querySelector('[data-pendant-prices]').textContent);
        this.section = this.closest('.shopify-section');
        this.onSectionChange = () => this.updateTotal();
        this.section.addEventListener('change', this.onSectionChange);
        this.addEventListener('change', event => {
          if (!event.target.matches('input[type="radio"]')) return;
          const selected = event.target;
          this.selectedVariant = selected.value;
          this.selectedTitle = selected.dataset.title;
          this.selectedPrice = Number(selected.dataset.price);
          this.querySelector('[data-chain-label]').textContent = this.selectedTitle;
          this.querySelector('[data-chain-surcharge]').textContent = selected.dataset.money;
          const preview = selected.parentElement.querySelector('.lr-chain__art').firstElementChild.cloneNode(true);
          if (preview.tagName === 'IMG') { preview.loading = 'eager'; preview.sizes = '86px'; }
          this.querySelector('[data-chain-thumb]').replaceChildren(preview);
          this.section.classList.toggle('lr-has-chain', Boolean(this.selectedVariant));
          this.updateTotal();
          this.querySelector('modal-dialog').hide();
        });
      }
      disconnectedCallback() { this.section?.removeEventListener('change', this.onSectionChange); }
      updateTotal() {
        const total = this.querySelector('[data-chain-total]');
        total.hidden = !this.selectedVariant;
        if (!this.selectedVariant) return;
        const id = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="id"]')?.value;
        const price = Number(this.prices[id]);
        if (!Number.isFinite(price)) { total.hidden = true; return; }
        total.querySelector('strong').textContent = new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:this.dataset.currency || 'USD'}).format((price + this.selectedPrice) / 100);
      }
      buildCartData(original) {
        const data = new FormData();
        for (const [key,value] of original.entries()) {
          if (key === 'id' || key === 'quantity' || key === 'selling_plan') data.append(`items[0][${key}]`,value);
          else if (key.startsWith('properties[')) data.append(`items[0][properties]${key.slice(10)}`,value);
          else data.append(key,value);
        }
        if (!original.has('quantity')) data.append('items[0][quantity]','1');
        data.append('items[1][id]',this.selectedVariant);
        data.append('items[1][quantity]',original.get('quantity') || '1');
        data.append('items[1][properties][For pendant]',this.dataset.productTitle);
        data.append('items[1][properties][_pendant_variant]',original.get('id'));
        return data;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lumerune-infinite-products"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('lr-infinite-products')) {
  customElements.define('lr-infinite-products', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.link = this.querySelector('.lr-infinite-next');
      this.list = this.closest('#product-grid')?.querySelector('[data-product-column]');
      if (!this.link || !this.list || !('IntersectionObserver' in window)) return;
      this.events = new AbortController();
      this.retry = this.querySelector('.lr-infinite-retry');
      this.status = this.querySelector('.lr-infinite-status');
      this.seen = new Set([...this.list.children].map(card => this.productKey(card)).filter(Boolean));
      this.page = Number(new URL(location.href).searchParams.get('page') || 1);
      this.attempts = 0;
      this.done = false;
      this.setAttribute('data-ready', '');
      this.retry.addEventListener('click', () => { this.attempts = 0; this.loadNext(); }, { signal:this.events.signal });
      window.addEventListener('online', () => { this.attempts = 0; if (this.nearEnd()) this.loadNext(); }, { signal:this.events.signal });
      this.checkEnd = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => {
          if (!this.done && !this.busy && this.isConnected && this.nearEnd() && !this.hasAttribute('data-error')) this.loadNext();
        });
      };
      // Keep a throttled fallback for fast scrolls that jump past the observer's sentinel.
      window.addEventListener('scroll', () => {
        if (this.done || this.busy || this.scrollTimer) return;
        this.scrollTimer = setTimeout(() => {
          this.scrollTimer = null;
          this.checkEnd();
        }, 120);
      }, { passive:true, signal:this.events.signal });
      window.addEventListener('resize', this.checkEnd, { passive:true, signal:this.events.signal });
      this.observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting) && !this.hasAttribute('data-error')) this.loadNext();
      }, { rootMargin:'0px 0px 450px 0px' });
      this.observer.observe(this);
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.controller?.abort();
      this.events?.abort();
      this.events = null;
      clearTimeout(this.timer);
      clearTimeout(this.timeout);
      clearTimeout(this.scrollTimer);
      cancelAnimationFrame(this.frame);
    }
    productKey(card) {
      const href = card.querySelector('a[href*="/products/"]')?.getAttribute('href');
      return href ? new URL(href, location.href).pathname.split('/products/')[1] : '';
    }
    nearEnd() { return this.getBoundingClientRect().top <= window.innerHeight + 450; }
    updateItemList(nextGrid) {
      const selector = 'script[data-lr-collection-itemlist]';
      const script = this.closest('#product-grid')?.querySelector(selector);
      const incoming = nextGrid.querySelector(selector);
      if (!script || !incoming) return;
      try {
        const current = JSON.parse(script.textContent);
        const next = JSON.parse(incoming.textContent);
        const byProduct = new Map([...current.itemListElement, ...next.itemListElement].map(item =>
          [new URL(item.url, location.href).pathname.split('/products/')[1], item]
        ));
        const start = current.itemListElement[0]?.position || 1;
        const items = [...this.list.children].map(card => byProduct.get(this.productKey(card)));
        if (items.some(item => !item)) return;
        current.itemListElement = items.map((item, index) => ({ ...item, position: start + index }));
        current.numberOfItems = next.numberOfItems;
        script.textContent = JSON.stringify(current).replace(/</g, '\\u003c');
      } catch {}
    }
    async readPage(url) {
      const response = await fetch(url, { signal:this.controller.signal, credentials:'same-origin' });
      if (!response.ok) throw new Error('Product page unavailable');
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const grid = doc.querySelector('#product-grid');
      if (!grid?.querySelector('[data-product-column]')?.children.length) throw new Error('Product grid unavailable');
      return grid;
    }
    async loadNext() {
      if (this.busy || this.done || !this.isConnected) return;
      clearTimeout(this.timer);
      this.busy = true;
      this.removeAttribute('data-error');
      this.retry.hidden = true;
      this.setAttribute('aria-busy', 'true');
      this.status.textContent = this.status.dataset.loading;
      this.controller = new AbortController();
      this.timeout = setTimeout(() => this.controller.abort(), 20000);
      try {
        const url = new URL(this.link.href, location.href);
        const base = new URL(location.href);
        const page = Number(url.searchParams.get('page'));
        if (url.origin !== base.origin || url.pathname !== base.pathname || !Number.isInteger(page) || page <= this.page) throw new Error('Invalid next page');
        url.searchParams.delete('section_id');
        if (base.searchParams.has('preview_theme_id')) url.searchParams.set('preview_theme_id', base.searchParams.get('preview_theme_id'));
        let nextGrid;
        if (!this.fullPages) {
          const sectionURL = new URL(url);
          sectionURL.searchParams.set('section_id', this.closest('#product-grid').dataset.id);
          try { nextGrid = await this.readPage(sectionURL); }
          catch (error) { if (error.name === 'AbortError') throw error; this.fullPages = true; }
        }
        if (!nextGrid) nextGrid = await this.readPage(url);
        if (!this.isConnected) return;
        const cards = [...nextGrid.querySelector('[data-product-column]').children];
        const fragment = document.createDocumentFragment();
        let added = 0;
        for (const card of cards) {
          const key = this.productKey(card);
          if (!key || this.seen.has(key)) continue;
          this.seen.add(key);
          card.querySelectorAll('img').forEach(img => { img.loading = 'lazy'; img.decoding = 'async'; img.setAttribute('fetchpriority', 'auto'); });
          fragment.append(card);
          added++;
        }
        if (!added) throw new Error('No new products');
        this.list.append(fragment);
        this.updateItemList(nextGrid);
        this.page = page;
        this.attempts = 0;
        const next = nextGrid.querySelector('lr-infinite-products .lr-infinite-next');
        if (next) {
          this.link.href = new URL(next.getAttribute('href'), url).href;
          this.status.textContent = this.dataset.loaded;
        } else {
          this.done = true;
          this.observer.disconnect();
          this.link.remove();
          this.status.textContent = this.dataset.done;
          this.setAttribute('data-complete', '');
        }
      } catch (error) {
        if (!this.isConnected) return;
        this.setAttribute('data-error', '');
        this.status.textContent = this.dataset.errorText;
        if (this.attempts < 2) {
          this.attempts++;
          this.timer = setTimeout(() => this.loadNext(), this.attempts * 1500);
        } else this.retry.hidden = false;
      } finally {
        clearTimeout(this.timeout);
        this.busy = false;
        this.removeAttribute('aria-busy');
        if (this.isConnected && !this.done && !this.hasAttribute('data-error')) {
          this.observer.unobserve(this);
          this.observer.observe(this);
          this.checkEnd();
        }
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lumerune-material-carousel"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('lumerune-material-carousel')) {
    customElements.define('lumerune-material-carousel', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.lr-materials__track');
        this.cards = Array.from(this.querySelectorAll('.lr-materials__item'));
        this.previous = this.querySelector('[data-direction="previous"]');
        this.next = this.querySelector('[data-direction="next"]');
        this.controls = this.querySelector('.lr-materials__controls');
        if (!this.track || !this.cards.length) return;

        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.previous.addEventListener('click', () => this.move(-1), options);
        this.next.addEventListener('click', () => this.move(1), options);
        this.track.addEventListener('scroll', () => this.scheduleUpdate(), { ...options, passive: true });
        this.track.addEventListener('keydown', (event) => {
          if (event.target !== this.track) return;
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            this.move((event.key === 'ArrowRight' ? 1 : -1) * this.direction);
          } else if (event.key === 'Home' || event.key === 'End') {
            event.preventDefault();
            this.scrollToPosition(event.key === 'Home' ? 0 : this.maximum);
          }
        }, options);
        this.resizeObserver = new ResizeObserver(() => this.scheduleUpdate());
        this.resizeObserver.observe(this.track);
        this.scheduleUpdate();
      }

      disconnectedCallback() {
        this.events?.abort();
        this.resizeObserver?.disconnect();
        cancelAnimationFrame(this.updateFrame);
      }

      get direction() { return getComputedStyle(this.track).direction === 'rtl' ? -1 : 1; }
      get maximum() { return Math.max(0, this.track.scrollWidth - this.track.clientWidth); }

      scrollToPosition(position) {
        this.track.scrollTo({
          left: Math.max(0, Math.min(this.maximum, position)) * this.direction,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
        });
      }

      move(direction) {
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const step = this.cards[0].getBoundingClientRect().width + gap;
        const page = Math.max(1, Math.floor((this.track.clientWidth + gap) / step));
        this.scrollToPosition(Math.abs(this.track.scrollLeft) + direction * page * step);
      }

      scheduleUpdate() {
        cancelAnimationFrame(this.updateFrame);
        this.updateFrame = requestAnimationFrame(() => this.update());
      }

      update() {
        const offset = Math.abs(this.track.scrollLeft);
        const maximum = this.maximum;
        this.controls.hidden = maximum < 2;
        this.previous.disabled = offset < 2;
        this.next.disabled = offset >= maximum - 2;

      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lumerune-material-picker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('lumerune-material-picker')) {
    customElements.define('lumerune-material-picker', class extends HTMLElement {
      connectedCallback() {
        this.section = document.getElementById('ProductInfo-' + this.dataset.section);
        this.picker = this.section?.querySelector('variant-radios, variant-selects');
        if (!this.picker) return;
        customElements.whenDefined(this.picker.localName).then(() => this.initialize());
      }

      initialize() {
        if (!this.isConnected || this.initialized) return;
        this.index = Number(this.dataset.optionPosition) - 1;
        this.groups = Array.from(this.picker.querySelectorAll('fieldset, .product-form__input--dropdown'));
        this.nativeGroup = this.groups[this.index];
        this.dialog = this.querySelector('dialog');
        this.trigger = this.querySelector('.lr-material__trigger');
        this.choices = Array.from(this.querySelectorAll('[data-material-choice]'));
        if (!this.nativeGroup || !this.dialog?.showModal) return;
        this.initialized = true;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.trigger.addEventListener('click', () => this.open(), options);
        this.querySelector('[data-material-close]').addEventListener('click', () => this.close(), options);
        this.dialog.addEventListener('cancel', (event) => { event.preventDefault(); this.close(); }, options);
        this.dialog.addEventListener('click', (event) => {
          if (event.target !== this.dialog) return;
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.close();
        }, options);
        this.dialog.addEventListener('close', () => this.restore(), options);
        this.choices.forEach((choice) => choice.addEventListener('click', () => this.select(choice), options));
        this.picker.addEventListener('change', () => this.sync(), options);
        this.nativeGroup.classList.add('lr-material-native');
        this.nativeGroup.hidden = true;
        this.hidden = false;
        this.sync();
      }

      values() {
        return this.groups.map((group) => group.querySelector('select')?.value ?? group.querySelector('input:checked')?.value);
      }

      sync() {
        const values = this.values();
        const value = values[this.index];
        this.querySelector('[data-material-value]').textContent = value;
        const variants = this.picker.getVariantData();
        this.choices.forEach((choice) => {
          const selected = choice.dataset.materialChoice === value;
          choice.setAttribute('aria-pressed', String(selected));
          const exists = variants.some((variant) => variant.options.every((option, index) => option === (index === this.index ? choice.dataset.materialChoice : values[index])));
          choice.disabled = !exists;
          choice.querySelector('.lr-material__unavailable').hidden = exists;
          if (selected) {
            const img = choice.querySelector('img');
            if (img) {
              const thumbnail = img.cloneNode();
              thumbnail.loading = 'eager';
              thumbnail.sizes = '76px';
              this.querySelector('[data-material-thumb]').replaceChildren(thumbnail);
            }
          }
        });
      }

      open() {
        if (this.dialog.open) return;
        this.sync();
        this.previousOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        this.dialog.classList.remove('is-closing');
        this.dialog.showModal();
        this.trigger.setAttribute('aria-expanded', 'true');
        (this.choices.find((choice) => choice.getAttribute('aria-pressed') === 'true') || this.querySelector('[data-material-close]')).focus({ preventScroll: true });
      }

      close() {
        if (!this.dialog.open || this.dialog.classList.contains('is-closing')) return;
        this.dialog.classList.add('is-closing');
        const duration = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 220;
        this.closeTimer = window.setTimeout(() => this.dialog.close(), duration);
      }

      restore() {
        window.clearTimeout(this.closeTimer);
        this.dialog.classList.remove('is-closing');
        document.body.style.overflow = this.previousOverflow ?? '';
        this.trigger.setAttribute('aria-expanded', 'false');
        if (this.isConnected) this.trigger.focus({ preventScroll: true });
      }

      select(choice) {
        const value = choice.dataset.materialChoice;
        const select = this.nativeGroup.querySelector('select');
        const input = select || Array.from(this.nativeGroup.querySelectorAll('input[type="radio"]')).find((radio) => radio.value === value);
        if (!input) return;
        if (select) select.value = value;
        else input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
        this.close();
      }

      disconnectedCallback() {
        this.abort?.abort();
        window.clearTimeout(this.closeTimer);
        if (this.dialog?.open) {
          this.dialog.close();
          document.body.style.overflow = this.previousOverflow ?? '';
        }
        this.initialized = false;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lumerune-size-guide"] && !Shopify.designMode) return;
  try {
    function enhanceFitGuides(root=document){
  root.querySelectorAll('.lr-size-guide__body[data-guide-type="rings"]').forEach(body=>{
    if(body.querySelector('.lr-fit-tabs'))return;
    const content=body.querySelector('.lf-grid>div');
    const headings=content?.querySelectorAll('h3');
    if(!headings||headings.length<2)return;
    const tabs=document.createElement('div');tabs.className='lr-fit-tabs';tabs.setAttribute('role','tablist');
    const panels=[];const buttons=[];
    [body.dataset.ringTab,body.dataset.fingerTab].forEach((label,i)=>{
      const panel=document.createElement('div');panel.className='lr-fit-panel';panel.id=body.closest('modal-dialog').id+'-method-'+i;panel.setAttribute('role','tabpanel');panel.tabIndex=0;
      let node=headings[i];
      while(node&&node!==headings[i+1]&&node.tagName!=='DETAILS'){const next=node.nextSibling;panel.append(node);node=next;}
      const button=document.createElement('button');button.type='button';button.textContent=label;button.id=panel.id+'-tab';button.setAttribute('role','tab');button.setAttribute('aria-controls',panel.id);panel.setAttribute('aria-labelledby',button.id);
      tabs.append(button);panels.push(panel);buttons.push(button);
    });
    const figure=body.querySelector('.lf-figure');if(figure)panels[0].append(figure);
    content.prepend(tabs,...panels);
    const chart=content.querySelector('details');if(chart)chart.open=true;
    function select(i){buttons.forEach((button,j)=>{button.setAttribute('aria-selected',String(i===j));button.tabIndex=i===j?0:-1;panels[j].hidden=i!==j;});}
    buttons.forEach((button,i)=>{button.addEventListener('click',()=>select(i));button.addEventListener('keydown',event=>{if(['ArrowLeft','ArrowRight','Home','End'].includes(event.key)){event.preventDefault();const next=event.key==='Home'?0:event.key==='End'?1:1-i;select(next);buttons[next].focus();}});});select(0);
  });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>enhanceFitGuides());else enhanceFitGuides();
document.addEventListener('shopify:section:load',event=>enhanceFitGuides(event.target));
  } catch(e) { console.error(e); }
})();

})();
